import React from "react";
import styles from "./Tiles.module.css";
import dbLogo from '../../assets/database_search_database_search.svg';
import { TileData } from '../../pages/bot/interfaces';

interface TileProps {
  title: string;
  content: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled : boolean;
  displayStatus: string;
  onArrowButtonClick?: () => void;
  tilesData: TileData[];
  isNew?: boolean;
}

const Tile: React.FC<TileProps> = ({ title, content, icon, onClick, disabled, displayStatus, onArrowButtonClick, tilesData, isNew }) => {
  // Determine if the arrow button should be enabled for HV Products and Services
  let arrowButtonDisabled = disabled;
  if (content === 'HV Products and Services' && tilesData) {
    const pghvDatabasesTile = tilesData.find(tile => tile.content === 'PGHV Databases');
    if (pghvDatabasesTile && pghvDatabasesTile.shouldBeDisabled === false) {
      arrowButtonDisabled = false;
    }else{
      arrowButtonDisabled = true;
    }
  }

  return (
    <div
      style={{ display: `${displayStatus}`, position: 'relative' }}
      className={`${styles.tile} ${disabled ? styles.disabled : ''}`}
      onClick={disabled ? undefined : onClick}
    >
      {isNew && (
        <span className={styles.newBadge}>NEW</span>
      )}
      <div style={{ fontSize: "26px", marginBottom: "4px" }}>{icon}</div>
      <h5 className={styles.title} style={title === "Zaragoza Engineering" ? { fontSize: "15px" } : {}}>{title}</h5>
      <p className={styles.content} style={title === "GRC Platforms" ? { fontSize: "12px" } : {}}>{content}</p>
      {content === 'HV Products and Services' && (
        <button
          type="button"
          className={`${styles.arrowButton} ${arrowButtonDisabled ? styles.disabled : ''}`}
          style={{
            position: "absolute",
            right: 12,
            bottom: 5,
            background: "none",
            border: "none",
            cursor: arrowButtonDisabled ? "not-allowed" : "pointer",
            outline: "none",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          tabIndex={-1}
          aria-label="Go"
          disabled={arrowButtonDisabled}
          onClick={e => { e.stopPropagation(); if (!arrowButtonDisabled && onArrowButtonClick) onArrowButtonClick(); }}
        >
          <img src={dbLogo} className={styles.for_db_logo} aria-hidden="true" alt="" />
          <span className={styles.tooltipDbButton}>Click to access HV Database Mode</span>
        </button>
      )}
    </div>
  );
};

export default Tile;
